var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "measure-box" }, [
    _vm.activeMeasure
      ? _c(
          "button",
          {
            staticClass: "measure-button-clear",
            on: { click: _vm.measureEnd },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("title", [_vm._v("delete")]),
                _vm._v(" "),
                _c("path", {
                  staticClass: "ruler-icon",
                  attrs: {
                    d: "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z",
                  },
                }),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.activeMeasure
      ? _c(
          "button",
          {
            staticClass: "measure-button",
            on: { click: _vm.measureDistanceStart },
          },
          [
            _c(
              "svg",
              {
                staticClass: "ruler-icon",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("title", [_vm._v("ruler")]),
                _vm._v(" "),
                _c("path", {
                  staticClass: "ruler-icon",
                  attrs: {
                    d: "M1.39,18.36L3.16,16.6L4.58,18L5.64,16.95L4.22,15.54L5.64,14.12L8.11,16.6L9.17,15.54L6.7,13.06L8.11,11.65L9.53,13.06L10.59,12L9.17,10.59L10.59,9.17L13.06,11.65L14.12,10.59L11.65,8.11L13.06,6.7L14.47,8.11L15.54,7.05L14.12,5.64L15.54,4.22L18,6.7L19.07,5.64L16.6,3.16L18.36,1.39L22.61,5.64L5.64,22.61L1.39,18.36Z",
                  },
                }),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.activeMeasure
      ? _c(
          "button",
          {
            staticClass: "measure-button",
            on: { click: _vm.measureSurfaceDistanceStart },
          },
          [
            _c(
              "svg",
              {
                staticClass: "ruler-icon",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("title", [_vm._v("ruler")]),
                _vm._v(" "),
                _c("path", {
                  staticClass: "ruler-icon",
                  attrs: {
                    d: "M1.39,18.36L3.16,16.6L4.58,18L5.64,16.95L4.22,15.54L5.64,14.12L8.11,16.6L9.17,15.54L6.7,13.06L8.11,11.65L9.53,13.06L10.59,12L9.17,10.59L10.59,9.17L13.06,11.65L14.12,10.59L11.65,8.11L13.06,6.7L14.47,8.11L15.54,7.05L14.12,5.64L15.54,4.22L18,6.7L19.07,5.64L16.6,3.16L18.36,1.39L22.61,5.64L5.64,22.61L1.39,18.36Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "ruler-icon terrain",
                  attrs: {
                    d: "M 17.12 15.12 L 15.32 17.52 L 16.688 19.344 L 15.92 19.92 C 15.1088 18.84 13.76 17.04 13.76 17.04 L 10.88 20.88 H 21.44 L 17.12 15.12 Z",
                  },
                }),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.activeMeasure
      ? _c(
          "button",
          {
            staticClass: "measure-button",
            on: { click: _vm.measureAreaStart },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("title", [_vm._v("ruler-square")]),
                _vm._v(" "),
                _c("path", {
                  staticClass: "ruler-icon",
                  attrs: {
                    d: "M3,5V21H9V19.5H7V18H9V16.5H5V15H9V13.5H7V12H9V10.5H5V9H9V5H10.5V9H12V7H13.5V9H15V5H16.5V9H18V7H19.5V9H21V3H5A2,2 0 0,0 3,5M6,7A1,1 0 0,1 5,6A1,1 0 0,1 6,5A1,1 0 0,1 7,6A1,1 0 0,1 6,7Z",
                  },
                }),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.measureResult
      ? _c("div", { staticClass: "measure-result" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.measureResult + " " + _vm.measureResultUnits) +
              "\n  "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }